import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Box, TextField, InputAdornment } from '@mui/material';
export const GcrRangeInput = ({ value, onChange, onBlur, onKeyDown, }) => {
    const [fromValue, setFromValue] = useState('');
    const [toValue, setToValue] = useState('');
    // Parse the incoming value (e.g., "10-20%" or "90%+")
    useEffect(() => {
        const parseValue = (val) => {
            if (val.includes('+')) {
                // Open-ended range like "90%+"
                const match = val.match(/^(\d+(?:\.\d+)?)%\+$/);
                if (match) {
                    setFromValue(match[1]);
                    setToValue('');
                    return;
                }
            }
            else {
                // Range like "10-20%"
                const match = val.match(/^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)%$/);
                if (match) {
                    setFromValue(match[1]);
                    setToValue(match[2]);
                    return;
                }
            }
            // Default/fallback
            setFromValue('');
            setToValue('');
        };
        parseValue(value);
    }, [value]);
    const handleSave = () => {
        if (!fromValue || isNaN(Number(fromValue))) {
            onChange('');
            return;
        }
        // If toValue is empty or invalid, make it open-ended
        if (!toValue || isNaN(Number(toValue))) {
            onChange(`${fromValue}%+`);
        }
        else {
            onChange(`${fromValue}-${toValue}%`);
        }
        onBlur();
    };
    const handleFromKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            // Focus to the "to" field when Enter is pressed in "from" field
            const toInput = document.querySelector('[data-testid="gcr-to-input"]');
            if (toInput)
                toInput.focus();
        }
        else if (e.key === 'Tab' && !toValue) {
            // Auto-focus to the "to" field when tabbing from "from" field
            e.preventDefault();
            const toInput = document.querySelector('[data-testid="gcr-to-input"]');
            if (toInput)
                toInput.focus();
        }
        else {
            onKeyDown(e);
        }
    };
    const handleToKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        }
        else {
            onKeyDown(e);
        }
    };
    const handleToBlur = () => {
        handleSave();
    };
    return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, width: '100%' }, children: [_jsx(TextField, { size: "small", type: "number", value: fromValue, onChange: (e) => setFromValue(e.target.value), onKeyDown: handleFromKeyDown, placeholder: "From", inputProps: {
                    min: 0,
                    max: 100,
                    step: 0.1,
                    'data-testid': 'gcr-from-input'
                }, InputProps: {
                    endAdornment: _jsx(InputAdornment, { position: "end", children: "%" }),
                }, sx: { flex: 1 }, autoFocus: true }), _jsx(TextField, { size: "small", type: "number", value: toValue, onChange: (e) => setToValue(e.target.value), onKeyDown: handleToKeyDown, onBlur: handleToBlur, placeholder: "To (optional)", inputProps: {
                    min: fromValue ? Number(fromValue) : 0,
                    max: 100,
                    step: 0.1,
                    'data-testid': 'gcr-to-input'
                }, InputProps: {
                    endAdornment: _jsx(InputAdornment, { position: "end", children: "%" }),
                }, sx: { flex: 1 } })] }));
};
